(() => {
  if (window.__bpcProductPriceLayoutLoaded) return;
  window.__bpcProductPriceLayoutLoaded = true;

  let queued = false;
  let rendering = false;

  const getCents = (item) => {
    const stored = Number(item.dataset.bpcProductUsdCents);
    if (Number.isFinite(stored) && stored >= 0) return Math.round(stored);

    const raw = item.dataset.bpcUsdCents;
    if (raw == null || String(raw).trim() === '') return null;

    const source = Number(raw);
    if (!Number.isFinite(source) || source < 0) return null;

    const cents = Math.round(source);
    item.dataset.bpcProductUsdCents = String(cents);
    return cents;
  };

  const restoreUsd = (item, engine) => {
    const cents = getCents(item);
    if (!Number.isFinite(cents)) return null;

    const from = item.dataset.bpcPriceFrom === 'true';
    const text = `${from ? 'From ' : ''}${engine.formatUsd(cents / 100)}`;

    item.removeAttribute('data-bpc-usd-cents');
    item.removeAttribute('data-bpc-fx-key');
    if (item.textContent.trim() !== text) item.textContent = text;

    return cents;
  };

  const getMetaBlock = (root) => {
    const parent = root.parentElement;
    if (!parent) return null;

    parent.querySelectorAll(':scope > .bpc-product-price-meta').forEach((node) => {
      if (node.previousElementSibling !== root) node.remove();
    });

    let meta = root.nextElementSibling;
    if (!meta || !meta.classList.contains('bpc-product-price-meta')) {
      meta = document.createElement('div');
      meta.className = 'bpc-product-price-meta';
      meta.setAttribute('data-nosnippet', '');
      root.insertAdjacentElement('afterend', meta);
    }

    return meta;
  };

  const renderProductPrice = (root, engine) => {
    root.querySelectorAll('.price-item[data-bpc-usd-cents],.price-item[data-bpc-product-usd-cents]').forEach((item) => {
      restoreUsd(item, engine);
    });

    root.querySelectorAll(
      '.bpc-product-price-approx-label,.bpc-product-checkout-usd,:scope > .bpc-product-local-estimate,:scope > .bpc-product-currency-note'
    ).forEach((node) => node.remove());

    const visible = root.classList.contains('price--on-sale')
      ? root.querySelector('.price__sale .price-item--sale')
      : root.querySelector('.price__regular .price-item--regular');

    if (!visible) return;

    const cents = Number(visible.dataset.bpcProductUsdCents);
    if (!Number.isFinite(cents) || cents < 0) return;

    const localValue = engine.toLocal(cents / 100);
    if (!Number.isFinite(localValue) || localValue <= 0) return;

    const from = visible.dataset.bpcPriceFrom === 'true';
    const localText = `(approx. ${from ? 'from ' : ''}${engine.formatLocal(localValue)})`;
    const key = `${cents}:${engine.rate}:${engine.buffer}:${engine.currency}:${from ? 'from' : 'fixed'}`;
    const meta = getMetaBlock(root);
    if (!meta) return;

    let local = meta.querySelector(':scope > .bpc-product-local-estimate');
    if (!local) {
      local = document.createElement('span');
      local.className = 'bpc-product-local-estimate';
      meta.appendChild(local);
    }

    if (local.dataset.bpcProductFxKey !== key || local.textContent !== localText) {
      local.textContent = localText;
      local.dataset.bpcProductFxKey = key;
    }

    let note = meta.querySelector(':scope > .bpc-product-currency-note');
    if (!note) {
      note = document.createElement('span');
      note.className = 'bpc-product-currency-note';
      meta.appendChild(note);
    }
    note.textContent = 'Checkout is charged in USD.';

    root.setAttribute(
      'aria-label',
      `${engine.formatUsd(cents / 100)}; approximately ${engine.formatLocal(localValue)} in local currency`
    );
  };

  const render = () => {
    queued = false;
    if (rendering) return;

    const engine = window.BpcCurrency;
    if (!engine || engine.currency === 'USD') return;

    rendering = true;
    document
      .querySelectorAll('.product__info-container [id^="price-"] .price--large,.product__info-container .price--large')
      .forEach((root) => renderProductPrice(root, engine));
    rendering = false;
  };

  const schedule = () => {
    if (queued || rendering) return;
    queued = true;
    requestAnimationFrame(() => requestAnimationFrame(render));
  };

  document.addEventListener('bpc:currency-ready', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  if (window.BpcCurrency) schedule();

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
